import {
  GET_ALL_COATING_PUMPHOUSE,
  GET_ALL_COATING_PUMPHOUSE_SUCCESS,
  GET_ALL_COATING_PUMPHOUSE_FAILURE,
  CLEAR_COATING_PUMPHOUSE_DATA,
  BULK_SAVE_COATING_PUMPHOUSE,
  BULK_SAVE_COATING_PUMPHOUSE_SUCCESS,
  BULK_SAVE_COATING_PUMPHOUSE_FAILURE,
  CLEAR_BULK_SAVE_COATING_PUMPHOUSE,
  SAVE_PUMP_HOUSE_LIMIT_CONFIG,
  SAVE_PUMP_HOUSE_LIMIT_CONFIG_SUCCESS,
  SAVE_PUMP_HOUSE_LIMIT_CONFIG_FAILURE,
} from './types';

// GET all
export const getAllCoatingPumphouse = (payload) => ({
  type: GET_ALL_COATING_PUMPHOUSE,
  payload,
});
export const getAllCoatingPumphouseSuccess = (payload) => ({
  type: GET_ALL_COATING_PUMPHOUSE_SUCCESS,
  payload,
});
export const getAllCoatingPumphouseFailure = (error) => ({
  type: GET_ALL_COATING_PUMPHOUSE_FAILURE,
  error,
});
export const clearCoatingPumphouseData = () => ({
  type: CLEAR_COATING_PUMPHOUSE_DATA,
});

// POST bulk save
export const bulkSaveCoatingPumphouse = (payload) => ({
  type: BULK_SAVE_COATING_PUMPHOUSE,
  payload,
});
export const bulkSaveCoatingPumphouseSuccess = (payload) => ({
  type: BULK_SAVE_COATING_PUMPHOUSE_SUCCESS,
  payload,
});
export const bulkSaveCoatingPumphouseFailure = (error) => ({
  type: BULK_SAVE_COATING_PUMPHOUSE_FAILURE,
  error,
});
export const clearBulkSaveCoatingPumphouse = () => ({
  type: CLEAR_BULK_SAVE_COATING_PUMPHOUSE,
});

/**
 * Save pump-house limit / UI config for the current user.
 * payload: { userEmailId, userId?, projectId, pipeId, limits, active, maxRows?, defaultPageSize? }
 */
export const savePumpHouseLimitConfig = (payload) => ({
  type: SAVE_PUMP_HOUSE_LIMIT_CONFIG,
  payload,
});
export const savePumpHouseLimitConfigSuccess = (payload) => ({
  type: SAVE_PUMP_HOUSE_LIMIT_CONFIG_SUCCESS,
  payload,
});
export const savePumpHouseLimitConfigFailure = (error) => ({
  type: SAVE_PUMP_HOUSE_LIMIT_CONFIG_FAILURE,
  error,
});
